<template>
    <div :class="canvas !== null ? `active active--${canvas}` : ''" @click="$store.commit('canvas/canvasHandler', null)" id="app">
        <router-view />
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

// import { properties, property, operations, types, suggestions } from '@/services/ApiMapaprop'

export default {
    computed: {
        ...mapGetters({
            canvas: 'canvas/canvas',
            modalCountry: 'modals/modalCountry'
        })
    },
    async created() {
        // const { data } = await properties({})
        // const { data } = await operations('AR')
        // const { data } = await suggestions({ term: 'buenos aires', country: 'AR', limit: 10 })
    }
}
</script>

<style lang="scss">
@import './scss/main.scss';
</style>
